import React from 'react';
import { render } from 'react-dom';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';

export class VideoWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //data: makeData(),
      //filtered: []
    };
  }

  render() {
    //console.log(authHeader());
    console.log(this.props.selectedVideo);
    let url = '';
    /*if (this.props.player_id == 771) {
      url = apiServerUrl + '/stream?video_id=' + 2;
    } else if (this.props.player_id == 928) {
      url = apiServerUrl + '/stream?video_id=' + 3;
    } else if (this.props.player_id == 361) {
      url = apiServerUrl + '/stream?video_id=' + 1;
    } else if (this.props.player_id == 1952) {
      url = apiServerUrl + '/stream?video_id=' + 4;
    }*/
    url =
      apiServerUrl + '/stream?video_id=' + this.props.selectedVideo.video_id;

    //selectedVideo
    console.log(url);
    return (
      <div>
        <link
          href="https://vjs.zencdn.net/7.1.0/video-js.css"
          rel="stylesheet"
        />

        <script src="https://vjs.zencdn.net/ie8/ie8-version/videojs-ie8.min.js" />
        <script src="https://vjs.zencdn.net/7.1.0/video.js" />
        <video
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          width="640"
          height="264"
          poster="MY_VIDEO_POSTER.jpg"
          data-setup="{}"
        >
          <source src={url} type="video/mp4" />
          {/*}<source src="MY_VIDEO.webm" type='video/webm'/>*/}
          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">
              supports HTML5 video>
            </a>
          </p>
        </video>
      </div>
    );
  }
}

//export default PlayerCard;
//render(<PlayerCard />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/Components/VideoWrapper.js